import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

class HotelScroller extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
    };
  }
  render() {
    let start = false;
    let end = false;
    let value = false;

    let startCity = this.props.dates.start.place.city;
    let startState = this.props.dates.start.place.state;
    let startCountry = this.props.dates.start.place.country;
    let startName = this.props.dates.start.place.name;

    let endCity = this.props.dates.end.place.city;
    let endState = this.props.dates.end.place.state;
    let endCountry = this.props.dates.end.place.country;
    let endName = this.props.dates.end.place.name;
    
    if(startCity==null){
      start = `${startState}, ${startCountry}`;
    }
    if(startState==null){
      start = `${startCity}, ${startCountry}`;
    }
    if(startCountry==null){
      start = `${startCity}, ${startState}`;
    }
    if(startCity==null && startState==null){
      start = `${startName}, ${startCountry}`;
    }
    if(startState==null && startCountry==null){
      start = `${startCity}`;
    }
    if(startCity==null && startState==null && startCountry==null){
      if(startName==null){
        start = ' ';
      } else{
        start = `${startName}`;
      }
    }
    if(startCity!=null && startState!=null && startCountry!=null){
      if(startCity === startState){
        start = `${startCity}, ${startCountry}`;
      }else{
        if(startState === startCountry){
         start = `${startCity}, ${startCountry}`; 
       } else{
        start = `${startCity}, ${startState}, ${startCountry}`;
       }
      }
    }

    
    if(endCity==null){
      end = `${endState}, ${endCountry}`;
    }
    if(endState==null){
      end = `${endCity}, ${endCountry}`;
    }
    if(endCountry==null){
      end = `${endCity}, ${endState}`;
    }
    if(endCity==null && endState==null){
      end = `${endName}, ${endCountry}`;
    }
    if(endState==null && endCountry==null){
      end = `${endCity}`;
    }
    if(endCity==null && endState==null && endCountry==null){
      if(endName==null){
        end = ' ';
      } else{
        end = `${endName}`;
      }
    }
    if(endCity!=null && endState!=null && endCountry!=null){
      if(endCity === endState){
        end = `${endCity}, ${endCountry}`;
      }else{
        if(endState === endCountry){
         end = `${endCity}, ${endCountry}`; 
       } else{
        end = `${endCity}, ${endState}, ${endCountry}`;
       }
      }
    }

    if(start == end){
       value = `${start}`
    } else{
      value = `${start} - ${end}`
    }
    return (
      <div className="hotel-scroller">
        <Button bsStyle="default" onClick={this.props.prev}>
          <i className="fa fa-chevron-left fa-lg" />
        </Button>
        <strong className="date-selector">
        {value}
        </strong>
        <Button bsStyle="default" onClick={this.props.next}>
          <i className="fa fa-chevron-right fa-lg" />
        </Button>
      </div>
    );
  }
}

HotelScroller.propTypes = {
  current: PropTypes.number.isRequired,
  end: PropTypes.number.isRequired,
  dates: PropTypes.object.isRequired,
  next: PropTypes.func.isRequired,
  prev: PropTypes.func.isRequired,
};
export default HotelScroller;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelScroller.js